import { object } from 'yup';

import { buildFields } from '../base/builders/buildValidationFields';

export default () => {
    const {
        name,
        parameters,
        parameters_commission_credit,
        parameters_hitch,
        parameters_rate,
    } = buildFields();

    const schema = {
        name,
        parameters: object().shape({
            tax: parameters.tax,
            terms: parameters.terms,
        }),
        parameters_commission_credit,
        parameters_hitch,
        parameters_rate,
    };

    return object().shape(schema);
};
